export default __webpack_public_path__ + "static/media/READY_TO_SCAN_ITEMS.758b3655.svg";